import { render } from "./Confirmar.vue?vue&type=template&id=6cd755dd"
import script from "./Confirmar.vue?vue&type=script&lang=js"
export * from "./Confirmar.vue?vue&type=script&lang=js"

import "./Confirmar.vue?vue&type=style&index=0&id=6cd755dd&lang=css"

import exportComponent from "/home/thales/Projetos/aceite-eletronico/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__